import { observer } from 'mobx-react'
import React, { useId } from 'react'

import {
   IconButton,
   IconButtonHierarchy,
   IconButtonSubVariant
} from '@flowwai-frontend/design-system'
import { ReverseLeftIcon } from '@flowwai-frontend/design-system/icons'
import { useMapsUtilityContext } from '../../../hooks/useMapsUtilityContext'
import MapTooltip from '../../MapTooltip/MapTooltip'

interface Props {
   isGeoShapeChanged: boolean
   onUndo: () => void
}

const UndoTool = (props: Props): React.ReactElement => {
   const { isGeoShapeChanged, onUndo } = props

   const tooltipId = useId()

   const { mapsT } = useMapsUtilityContext()

   if (!isGeoShapeChanged) return <></>

   return (
      <React.Fragment>
         <IconButton
            icon={({ stroke }) => <ReverseLeftIcon stroke={stroke} />}
            size={'Small'}
            hierarchy={IconButtonHierarchy.Tertiary}
            subVariant={IconButtonSubVariant.Gray}
            onClick={onUndo}
            data-tooltip-id={tooltipId}
         />
         <MapTooltip content={mapsT('undo')} tooltipId={tooltipId} />
      </React.Fragment>
   )
}

export default observer(UndoTool)
